import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  height: ${grid.xl};
`;

export const TabsHeader = styled.div`
  height: auto;
  background: ${colors.white};

  .MuiTabs-root {
    min-height: 0;
  }

  .MuiTab-root {
    text-transform: none;
    min-width: 0;
    min-height: 0;
    padding: 0 0 ${grid.md} 0;

    margin-right: ${grid.lg};
  }

  .MuiTab-wrapper {
    height: ${grid.lg};
  }

  .MuiTabs-flexContainer {
    border-bottom: 1px solid #e6e6e6;
  }

  .MuiTab-textColorInherit {
    color: #b3b3b3;
    font-size: ${grid.md};
    font-weight: bold;
  }

  .MuiTab-textColorInherit.Mui-selected {
    color: #1a1a1a;
    font-weight: bold;
  }

  .MuiTabs-indicator {
    border: 2px solid ${colors.primary};
    border-radius: 5px;
  }
`;
